import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService } from '@tcc-mono/shared/data-access';
import { Contact } from '@tcc-mono/vandijk/shared/data-access/models';

@Injectable({
  providedIn: 'root'
})
export class ContactService extends BaseService<Contact> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/contact_persons'
  }
}
